// extracted by mini-css-extract-plugin
export default {"toggleSwitchWrapper":"styles_toggleSwitchWrapper__GlzzK","toggleSwitch":"styles_toggleSwitch__BUDjq","slider":"styles_slider__4q+0v","labelText":"styles_labelText__UnWvO"};